/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Box, Flex, StylesProvider, useMultiStyleConfig} from '@chakra-ui/react'
import HybridLink from '../../../components/hybrid-link'
import LinksList from '../../../components/links-list'
import {StokkeWordBrandLogo} from '../../../components/icons'
import {HYBRID_HOME} from '../../../constants'
import PaymentIcons from '../../../components/footer/payment-icons'
import ShippingIcons from '../../../components/footer/shipping-icons'

const CheckoutFooter = ({footerContent}) => {
    const styles = useMultiStyleConfig('FooterContent')
    const intl = useIntl()
    const brandText = intl.formatMessage({defaultMessage: 'STOKKE Logo', id: 'global.brand_logo'})
    const backToHomePage = intl.formatMessage({
        defaultMessage: 'Back to homepage',
        id: 'global.back_to_home'
    })
    const links = footerContent?.c_body?.innerJSON?.links || {items: []}

    return (
        <Box as="footer" {...styles.container}>
            <Box {...styles.content.boxing}>
                <Flex {...styles.content}>
                    <StylesProvider value={styles}>
                        <Box {...styles.StokkeWordBrandLogo.link}>
                            <HybridLink
                                page={HYBRID_HOME}
                                href="/home"
                                title={backToHomePage}
                                variant="image"
                            >
                                <StokkeWordBrandLogo
                                    {...styles.StokkeWordBrandLogo.logo}
                                    role="img"
                                    aria-label={brandText}
                                />
                            </HybridLink>
                        </Box>
                        {links?.items?.length && (
                            <Box {...styles.footerLinkContainer}>
                                <LinksList variant="checkoutFooter" links={links.items} />
                            </Box>
                        )}
                        <Box {...styles.footerIconContainer}>
                            <PaymentIcons />
                            <ShippingIcons />
                        </Box>
                    </StylesProvider>
                </Flex>
            </Box>
        </Box>
    )
}

CheckoutFooter.propTypes = {
    props: PropTypes.object,
    content: PropTypes.object,
    cid: PropTypes.string,
    footerContent: PropTypes.object
}

export default CheckoutFooter
